"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = __importDefault(require("./colors"));
var typography_1 = __importDefault(require("./typography"));
exports.default = {
    primaryLabel: {
        display: "inline-block",
        position: "absolute",
        width: "auto",
        left: 1,
        top: "50%",
        transform: "translateY(-50%)",
        m: 0,
        p: 0,
        // Custom paddings due to the specificity of the label position
        pl: "11px",
        pr: "5px",
        fontSize: 1,
        fontWeight: "" + typography_1.default.fontWeights.body,
        color: colors_1.default.grey300,
        transition: "0.2s ease-out",
        letterSpacing: typography_1.default.letterSpacing.label,
        // If input is focused or placeholder is not visible (e.g. it has a value), we raise the label to the top of the input
        "input:focus + &, input:not(:placeholder-shown) + &": {
            top: 0,
            transform: "translateY(-50%)",
            background: "linear-gradient(to top, " + colors_1.default.backgroundBlue + " calc(50% + 2.5px), transparent calc(50% + 2.5px))",
            fontSize: 0,
            fontWeight: "" + typography_1.default.fontWeights.bold,
            letterSpacing: typography_1.default.letterSpacing.largeHeading
        },
        // Additional vendor prefixes to raise the label to the top of the input when input is autofilled
        "input:-webkit-autofill + &, input:-moz-autofill + &": {
            animationName: "onAutoFillStart",
            top: 0,
            transform: "translateY(-50%)",
            background: "linear-gradient(to top, " + colors_1.default.backgroundBlue + " calc(50% + 2.5px), transparent calc(50% + 2.5px))",
            fontSize: 0,
            fontWeight: "" + typography_1.default.fontWeights.bold,
            letterSpacing: typography_1.default.letterSpacing.largeHeading
        },
    },
    primaryInput: {
        width: "100%",
        px: 2,
        border: "none",
        borderRadius: 0,
        color: colors_1.default.white,
        fontSize: 2,
        fontFamily: "body",
        fontWeight: "" + typography_1.default.fontWeights.body,
        ":focus": {
            outline: "none"
        },
        "::placeholder": {
            opacity: 0
        },
        // removes Edge built in show/hide password button
        "&::-ms-reveal, &::-ms-clear": {
            display: "none"
        },
        "&::-webkit-caps-lock-indicator, &::-webkit-credentials-auto-fill-button, &::-ms-reveal, &::-ms-clear": {
            backgroundColor: colors_1.default.white,
            "&:hover": {
                backgroundColor: colors_1.default.primary,
            }
        },
    },
    select: {
        border: "2px solid " + colors_1.default.primaryLight,
        borderRadius: 3,
        color: colors_1.default.primaryLight,
        fontSize: 2,
        minWidth: 7,
        pr: 4,
        width: "auto"
    }
};
